import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img
                src="/assets/logos/logo-sef-blanc.jpeg"
                alt="SEF Installation"
                style={{ borderRadius: '8px', padding: '6px', background: 'rgba(255,255,255,0.95)' }}
              />
            </div>
            <p>Expert en installation de panneaux solaires photovoltaïques, pompes à chaleur et isolation thermique à Lyon et sa région.</p>
            <div className="footer-address" style={{ marginTop: '15px' }}>
              <p>SEF INSTALLATION SAS<br />8 Rue Marc Bloch<br />69007 LYON</p>
            </div>
          </div>

          <div className="footer-section">
            <h4>Nos Solutions</h4>
            <ul>
              <li><Link to="/solutions/photovoltaique">Panneaux photovoltaïques</Link></li>
              <li><Link to="/solutions/pompes-chaleur">Pompes à chaleur</Link></li>
              <li><Link to="/solutions/isolation">Isolation thermique</Link></li>
              <li><Link to="/solutions/renovation-globale">Rénovation globale</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Informations</h4>
            <ul>
              <li><Link to="/tout-comprendre">Tout comprendre</Link></li>
              <li><Link to="/realisations">Nos réalisations</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p>
              <a href="tel:0465845177" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
                04 65 84 51 77
              </a>
            </p>
            <p>
              <a href="mailto:contact@sef-installation.fr" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
                contact@sef-installation.fr
              </a>
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} SEF INSTALLATION SAS. Tous droits réservés. | SIREN : 851 510 974 | Capital : 6 000 €</p>
        </div>
      </div>
    </footer>
  );
}
